export const isSystemDefaultThemeDarkMode =
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
